<div *ngIf="mapLoader.mapsLoaded | async" class="heatmap-wrapper" >
  <div *ngIf="isDataLoaded">  
    <google-map [zoom]="zoom" width="100%" aria-label="Map of Incidents">
      <map-heatmap-layer [data]="heatmapData" [options]="heatmapOptions"></map-heatmap-layer>
    </google-map>
  </div>
</div>
